import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SecureHashFunctionSHAModule = () => (
  <QPhototModuleSubtopic
    title="Secure Hash Function (SHA)"
    videos={[
      "https://www.youtube.com/embed/VtHSyoJkDXw"
    ]}
    takeaways={[
      {
        text:
          "Avoid short 10-minute YouTube videos for SHA that do not cover the full topic in depth."
      },
      {
        text:
          "Remember the Majority, Conditional, and Rotate functions; solve at least one numerical problem and practice using a calculator."
      }
    ]}
    questions={[
      {
        text:
          "Determine the number of padding bits, total length, and number of blocks used in HMAC for the hash functions SHA-512 and MD5 if the input message to be sent is M = 1011011100011110 and the key K = 10111011."
      },
      {
        text:
          "Evaluate the value of Ch(e, f, g) and Maj(a, b, c) of the SHA-512 algorithm for the buffers ‘a’, ‘b’, ‘c’, ‘e’, ‘f’, and ‘g’ that contain the hexadecimal values 1111777700001111, FFFF222222221111, BBBB999911112222, CCCC222222220000, 1111DDDD22221111, and 33331111AAAAFFFF, respectively."
      },
      {
        text:
          "In SHA-512, the 8, 64-bit buffers a, b, c, d, e, f, g, and h are initialized to the following hex values:\n\na = 6A09E667F3BCC908\nb = BB67AE8584CAA73B\nc = 3C6EF372FE94F82B\nd = A54FF53A5F1D36F1\ne = 510E527FADE682D1\nf = 9B05688C2B3E6C1F\ng = 1F83D9ABFB41BD6B\nh = 5BE0CD19137E2179\n\nCompute and show how the first 3 hex digits of buffer ‘b’ are computed."
      },
      {
        text:
          "In SHA-512, we take each 1024-bit message subblock and perform 80 rounds. For each of these rounds, we need to derive a 64-bit word W_t from the message subblock where t varies from 0 to 79. Explain with a neat block diagram how the key expansion happens in SHA-512."
      },
      {
        text:
          "David, a cybersecurity researcher, is analysing the security of a hashing algorithm used in digital forensics. As part of his research, he needs to compute a specific word in the SHA-512 message schedule expansion for a given set of 16-bit hexadecimal words. He has been provided with the following words: W0 = 0x1234, W1 = 0xFEDC, W2 = 0x0011, W3 = 0x8899, W9 = 0x5555, W14 = 0x1111. Using SHA-512’s word expansion and addition modulo 2^16, compute the value of W16."
      },
      {
        text:
          "Compute and show the result of the function used in SHA-512 round operations that acts on the first three buffers.a = 510E527FADE682D1,b = 9B05688C2B3E6C1F,c = 1F83D9ABFB41BD6B,d = 5BE0CD19137E2179,e = 6A09E667F3BCC908,f = BB67AE8584CAA73B,g = 3C6EF372FE94F82B,h = A54FF53A5F1D36F1"
      },
      {
        text:
          "At VIT, the VTOP Intranet portal maintains detailed system logs that record every user action, such as grade submissions, fee payments, and attendance updates. Each log entry is associated with the user's ID and timestamped to provide a record of activities. However, the system does not implement any mechanism to verify whether the data transmitted or stored has been altered. Does this system ensure integrity, non-repudiation, or both? Justify your answer with respect to security principles."
      },
      {
        text:
          "In SHA-512, the size of the original message is 1250 bits. What will be the number of padding bits?"
      },
      {
        text:
          "Given a plaintext \"VIT\", using the SHA-512 algorithm, derive the following information. Consider the ASCII values for the plaintext: V = 86, I = 73, T = 84.\n(a) Determine the length of padding bits required.\n(b) Generate the sixteen 64-bit words (W0 to W15) in hexadecimal format.\n(c) Compute the majority function of the round operation using buffers A, B, and C.\n(d) Compute the choice function of the round operation using buffers E, F, and G.\nGiven buffer values: A = 01100001, B = 01100010, C = 01100011, E = 01100101, F = 01100110, G = 01100111.\n(e) What are the essential characteristics that ensure the security of a cryptographic hash function?"
      },
      {
        text:
          "In SHA-512, the 8, 64-bit buffers a, b, c, d, e, f, g, and h are initialized to the following hex values:\n\na = 6A09E667F3BCC908\nb = BB67AE8584CAA73B\nc = 3C6EF372FE94F82B\nd = A54FF53A5F1D36F1\ne = 510E527FADE682D1\nf = 9B05688C2B3E6C1F\ng = 1F83D9ABFB41BD6B\nh = 5BE0CD19137E2179\n\nCompute and show how the first 3 hex digits of buffer ‘b’ are computed."
      },
      {
        text:
          "In SHA-512, we take each 1024-bit message subblock and perform 80 rounds. For each of these rounds, we need to derive a 64-bit word W_t from the message subblock where t varies from 0 to 79. Explain with a neat block diagram how the key expansion happens in SHA-512."
      },
      {
        text:
          "Evaluate the value of Ch(e, f, g) and Maj(a, b, c) of the SHA-512 algorithm for the buffers ‘a’, ‘b’, ‘c’, ‘e’, ‘f’, and ‘g’ that contain the hexadecimal values 1111777700001111, FFFF222222221111, BBBB999911112222, CCCC222222220000, 1111DDDD22221111, and 33331111AAAAFFFF, respectively."
      }
    ]}
    exampleVideos={[]}
  />
);

export default SecureHashFunctionSHAModule;
